import { getGuessStatuses } from '../../lib/statuses'
import { Cell } from './Cell'

type Props = {
  guess: string
  isRevealing?: boolean
}

export const CompletedRow = ({ guess, isRevealing }: Props) => {
  const statuses = getGuessStatuses(guess)

  return (
    <div className="flex justify-center mb-1">
      {guess
        .split('')
        .reverse()
        .map((letter, i) => (
          <Cell
            key={i}
            value={letter}
            status={statuses[4 - i]}
            position={i}
            isRevealing={isRevealing}
            isCompleted
          />
        ))}
    </div>
  )
}
